export const basePrefix = "/loyalty";

export const extendedPrefix = `${basePrefix}/:countryCode/:restaurantUnique/:program`;

const endpoints = {
  login: `${extendedPrefix}/auth/login`,
  registrationCheck: `${extendedPrefix}/auth/check-registration`,
  verify: `${extendedPrefix}/auth/login/verify`,
  logout: `${extendedPrefix}/auth/logout`,
  profile: `${extendedPrefix}/auth/profile`,
  refreshToken: `${extendedPrefix}/auth/refresh-token`,
  redeem: `${extendedPrefix}/points/burn`,
  earn: `${extendedPrefix}/points/earn`,
  getOffers: `${extendedPrefix}/offers`,
  applyOffers: `${extendedPrefix}/offers/apply`,
  eligibility: `${basePrefix}/burn/eligibility/:program`,
  getRestaurantLoyaltyPrograms: `${basePrefix}/:countryCode/:restaurantUnique/programs`,
  getLoyaltyProgramByCode: `${basePrefix}/programs/:code`,
  getProgramVenues: `${basePrefix}/:countryCode/:restaurantUnique/programs/:programId/venues`,
  getTransactions: `${basePrefix}/customer/transactions/:customerId`,
  register: `${extendedPrefix}/auth/register`,
  enrollForSubscription: `${basePrefix}/subscription/:subscriptionId/enroll`,
  cancelSubscription: `${basePrefix}/subscription/:subscriptionId/cancel`,
  getSubscriptionDiscount: `${basePrefix}/subscription/discount`
};

export default endpoints;
